import { lighten } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { error, info, neutralLight, success, warning } from '../colors'
import { getPrimary } from '../utils'

export const createPalette = (config) => {
    const { colorPreset, contrast } = config
    const primary = getPrimary(colorPreset)

    return {
        action: {
            active: neutralLight[600],
            disabled: alpha(neutralLight[900], 0.38),
            disabledBackground: alpha(neutralLight[900], 0.12),
            focus: alpha(primary.main, 0.16),
            hover: alpha(primary.main, 0.05),
            selected: alpha(primary.main, 0.09)
        },
        background: {
            default:
                contrast === 'high'
                    ? lighten(primary.main, 0.78)
                    : lighten(primary.main, 0.88),
            paper:
                contrast === 'high'
                    ? lighten(primary.main, 0.95)
                    : lighten(primary.main, 0.96)
        },
        divider: alpha(primary.main, 0.14),
        error,
        info,
        mode: 'light',
        neutral: neutralLight,
        primary,
        success,
        text: {
            primary: neutralLight[900],
            secondary: neutralLight[600],
            disabled: alpha(neutralLight[900], 0.38)
        },
        warning
    }
}
